import { ConflictErrorCode } from '@today/types'

/** How often a preview waits out a malware scan (TO-458 BR-10). */
export const PREVIEW_SCAN_RETRY_MS = 5000
/** Retries while scanning — about 2 minutes at {@link PREVIEW_SCAN_RETRY_MS}. */
export const PREVIEW_SCAN_MAX_RETRIES = 24
/** Every other failure keeps the app-wide query default (App.tsx). */
const DEFAULT_RETRIES = 1
const DEFAULT_MAX_DELAY_MS = 30_000

interface ApiErrorShape {
	response?: { status?: number; data?: { error?: { code?: string } } }
}

/** A 409 FILE_NOT_AVAILABLE: the file exists but is still being scanned. */
const isScanning = (error: unknown): boolean => {
	const response = (error as ApiErrorShape | null)?.response
	return response?.status === 409 && response.data?.error?.code === ConflictErrorCode.FILE_NOT_AVAILABLE
}

/** TanStack Query `retry` for an image preview URL. */
export const previewRetry = (failureCount: number, error: unknown): boolean =>
	failureCount < (isScanning(error) ? PREVIEW_SCAN_MAX_RETRIES : DEFAULT_RETRIES)

/** TanStack Query `retryDelay`: a steady 5 s while scanning, the library's backoff otherwise. */
export const previewRetryDelay = (failureCount: number, error: unknown): number =>
	isScanning(error) ? PREVIEW_SCAN_RETRY_MS : Math.min(1000 * 2 ** failureCount, DEFAULT_MAX_DELAY_MS)
